/** @jsxImportSource @emotion/react */
import MapboxGeocoder from '@mapbox/mapbox-gl-geocoder'
import '@mapbox/mapbox-gl-geocoder/dist/mapbox-gl-geocoder.css'
import { Box, useTheme } from '@mui/material'
import { Icon } from '@app/components/Atoms/Icon'
import { clientConfigAtom } from '@app/state/clientsAtom'
import { useAtomValue } from 'jotai'
import mapboxgl from 'mapbox-gl'
import { useEffect, useState } from 'react'
import { geocoderButtonBox, geocoderContainer } from './GeocoderButton.styles'

const geocoderContainerId = 'geocoder-container'
const DEFAULT_GEOCODER_COUNTRY = 'nz'

export const GeocoderButton = ({ map }: { map: mapboxgl.Map | null }) => {
  const theme = useTheme()
  const [showGeocoder, setShowGeocoder] = useState(false)
  const country_codes = useAtomValue(clientConfigAtom)?.country_codes
  const formattedCountries = country_codes?.join(',') ?? DEFAULT_GEOCODER_COUNTRY //if country_code is not defined, search fallback to NZ

  useEffect(() => {
    if (!map) return

    const existingDiv = document.getElementById(geocoderContainerId)
    if (!existingDiv) return

    while (existingDiv.firstChild) {
      existingDiv.firstChild.remove()
    }

    const geocoder = new MapboxGeocoder({
      accessToken: mapboxgl.accessToken,
      mapboxgl: mapboxgl,
      placeholder: 'Search by address',
      countries: formattedCountries,
    })

    existingDiv?.appendChild(geocoder.onAdd(map))
    geocoder.clear() // Also focuses the input
  }, [map, showGeocoder, formattedCountries])

  const handleButtonClick = () => {
    setShowGeocoder(!showGeocoder)
  }

  return (
    <Box
      sx={{ marginTop: theme.spacing(1), display: 'flex', flexDirection: 'row' }}
      className="tutorial-geocoder"
    >
      {showGeocoder && (
        <Box id={geocoderContainerId} component="span" css={geocoderContainer({ theme })} />
      )}
      <Box css={geocoderButtonBox({ theme })} onClick={handleButtonClick}>
        <Icon iconName="Search" />
      </Box>
    </Box>
  )
}
